module.exports = __webpack_public_path__ + "static/img/img9-1.5589359.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/shop/img9-1.png
// module id = UTW+
// module chunks = 0